module.exports = __webpack_public_path__ + "img/GS_Profiles-Anthony Mthembu.a557b75d.png";